import { FT } from 'ft'
import { Container, Text, TextStyle, mesh } from 'pixi.js'
import randomNumber from '@m31271n/random-number'
import copywritings from '#/copywritings'

const $bg = 'bed-subtitle-bg'
FT.rm.addImage($bg)

const normalStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 42,
  fill: '#d05e20',
})

const usernamePlusStyle = new TextStyle({
  fontFamily: 'sans-serif',
  fontSize: 34,
  fill: '#fb7050',
})

const usernameMinusStyle = new TextStyle({
  fontFamily: 'sans-serif',
  fontSize: 34,
  fill: '#4f894c',
})

const tempPlusStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 42,
  fill: '#fb7050',
})

const tempMinusStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 42,
  fill: '#4f894c',
})

const { NineSlicePlane } = mesh

class Content extends Container {
  constructor(username, temp) {
    super()

    const copywriting =
      temp >= 0 ? copywritings.increase : copywritings.decrease
    const index = randomNumber({
      min: 0,
      max: copywriting.length - 1,
      float: false,
      includeMax: true,
    })
    const $copywriting = copywriting[index]
    const { sentence, adj } = $copywriting

    const $username = new Text(
      username,
      temp >= 0 ? usernamePlusStyle : usernameMinusStyle
    )
    $username.anchor.set(0, 0.5)
    this.addChild($username)

    if (adj) {
      const $adj = new Text(adj, normalStyle)
      $adj.anchor.set(0, 0.5)
      this.addChild($adj)

      $username.x = $adj.x + $adj.width
    }

    const $text = new Text(sentence, normalStyle)
    $text.anchor.set(0, 0.5)
    $text.x = $username.x + $username.width
    this.addChild($text)

    const $temp = new Text(
      `${Math.abs(temp)}°C`,
      temp >= 0 ? tempPlusStyle : tempMinusStyle
    )
    $temp.anchor.set(0, 0.5)
    $temp.x = $text.x + $text.width
    this.addChild($temp)

    this.pivot.set(0, this.height / 2)
  }
}

class Subtitle extends NineSlicePlane {
  constructor(username, temp) {
    super(FT.rm.texture($bg), 36.5, 36.5, 24, 24)
    const xOffset = 24
    const content = new Content(username, temp)
    content.x = xOffset
    content.y = this.height - 12
    this.addChild(content)

    this.width = content.width + 2 * xOffset
  }
}

export default Subtitle
